import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { axiosClient } from './AxiosInstanceConfigs';

/**
 *
 * @param url Required type of string
 * @param token Optional type of string
 * @returns {Promise<AxiosResponse<T>>} Promise of generic type AxiosResponse of Generic type T
 */
export async function getRequest<T>(
  url: string,
  token?: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> {
  if (token) {
    const response = await axiosClient.get<T>(`/${url}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  }
  const response = await axiosClient.get<T>(`/${url}`, config);
  return response;
}

/**
 *
 * @param url Required type of string
 * @param payload Required type of Object
 * @param token Optional Type of string
 * @returns {Promise<AxiosResponse<T>>} Promise of generic type AxiosResponse of Generic type T
 */
export async function postRequest<T>(
  url: string,
  payload: object,
  token?: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> {
  if (token) {
    const response = await axiosClient.post<T>(`/${url}`, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  }
  const response = await axiosClient.post<T>(`/${url}`, payload, config);
  return response;
}

/**
 *
 * @param url Required type of string
 * @param payload Required type of Object
 * @param token Optional Type of string
 * @returns {Promise<AxiosResponse<T>>} Promise of generic type AxiosResponse of Generic type T
 */
export async function formDataPostRequest<T>(
  url: string,
  formData: FormData,
  token?: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<T>> {
  if (token) {
    const response = await axiosClient.post<T>(`/${url}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  }
  const response = await axiosClient.post<T>(`/${url}`, formData, config);
  return response;
}

/**
 *
 * @param url Required type of string
 * @param payload Required type of Object
 * @returns {Promise<AxiosResponse<T>>} Promise of generic type AxiosResponse of Generic type T
 */
export async function putRequest<T>(url: string, payload: object): Promise<AxiosResponse<T>> {
  const response = await axiosClient.put<T>(`/${url}`, payload);
  return response;
}

/**
 *
 * @param url Required type of string
 * @param payload Required type of Object
 * @returns {Promise<AxiosResponse<T>>} Promise of generic type AxiosResponse of Generic type T
 */
export async function patchRequest<T>(url: string, payload: object): Promise<AxiosResponse<T>> {
  const response = await axiosClient.patch<T>(`/${url}`, payload);
  return response;
}

/**
 *
 * @param url Required type of string
 * @returns {Promise<AxiosResponse<T>>} Promise of generic type AxiosResponse of Generic type T
 */
export async function deleteRequest<T>(url: string): Promise<AxiosResponse<T>> {
  const response = await axiosClient.delete<T>(`/${url}`);
  return response;
}
